/**
 * Import Lib
 */

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import t from 'theme';


/**
 * import containers & components
 */


/**
 * styled components
 */

const Container = styled.div`
  background-color: transparent;
`;

/**
   * Layout wrapper is used for outer page content
   */

const layout__wrapper = ({ style, children }) => (
  <Container style={style}>
    {children}
  </Container>
);

layout__wrapper.propTypes = {
  /**
    A custom style object
    */
  children: PropTypes.node,
  /**
    A children object to render content inside the components
    */
  style: PropTypes.object,
};

layout__wrapper.defaultProps = {
  style: {},
  children: null,
};

export default layout__wrapper;
